import React, { ReactNode } from 'react';
import { replaceUnderscore } from '../../../CommonFunction/common';
import { convertToAge } from '../../../CommonFunction/ProcessData';
import "./DisplayInfo.scss"
interface RenderDataProps {
    data: any;
}

const RenderData: React.FC<RenderDataProps> = ({ data }): ReactNode => {
    console.log(data, data?.createdAt, convertToAge(data?.createdAt), "age")


    if (typeof data === 'object') {
        return (
            <div
                className='DisplayContainer'
            >
                {Object.entries(data).map(([key, value], index) => (
                    // Exclude __typename from rendering

                    <div key={index} style={{

                        // border: '1px solid red'
                    }} className='firstBox' >
                        <h6 className="loadingDetailsText">  {replaceUnderscore(key)} : </h6>
                        <span className='value' >{" "}{String(value)}</span>
                    </div>

                ))}

            </div>
        );
    }


};

export { RenderData };
